import PropTypes from 'prop-types';

import { INVENTORY_WAREHOUSE_ERROR_CODE_MAP } from './constants';

export const InventoryWarehouseLocationPropType = PropTypes.shape({
  inventoryWarehouseId: PropTypes.string,
  inventoryLocationId: PropTypes.string,
  area: PropTypes.string,
  unit: PropTypes.string,
  shelf: PropTypes.string,
  bin: PropTypes.string,
  isActive: PropTypes.bool,
  createDate: PropTypes.string,
  isUnspecified: PropTypes.bool,
  isPickable: PropTypes.bool,
});

export const InventoryLocationDeleteErrorPropType = PropTypes.shape({
  code: PropTypes.string,
  message: PropTypes.string,
});

export const InventoryWarehouseDeleteErrorPropType = PropTypes.oneOf(Object.values(INVENTORY_WAREHOUSE_ERROR_CODE_MAP));
